module.exports = __webpack_public_path__ + "assets/img/f2.a2589bed.jpg";